<template>
    <div v-if="shadowStore.isShadowing">
        <DsButton
            class="relative flex items-center rounded bg-ds-orange-400 px-2 py-2 text-center align-middle text-sm text-white hover:bg-ds-orange-500 hover:text-white legacy-md:shadow-xl legacy-xl:px-3"
            size="md"
            variant="tertiary"
            @click="shadowStore.stopShadowing"
        >
            <span class="flex-1 font-inter font-normal">
                <span class="hidden md:inline-block lg:text-sm legacy-xl:text-base">
                    <span class="font-inter"> {{ !isExtraLarge ? '' : '🥸 You are shadowing ' }} </span>
                    <span class="font-inter font-bold">{{ shadowStore.shadowAccountName }}</span
                    >{{ !isExtraLarge ? '' : '.' }}
                </span>
                <span class="ml-1 text-xs underline hover:text-white legacy-md:text-sm legacy-xl:text-base">{{
                    'Stop Shadowing'
                }}</span>
            </span>
        </DsButton>
    </div>
</template>

<script setup lang="ts">
import { isExtraLarge } from '@/components/Composables/MobileScreenDetection';
import DsButton from '@/components/design-system/form/input/DsButton.vue';
import { useShadowAccountStore } from '@/stores/shared/shadow-account.store';

const shadowStore = useShadowAccountStore();
</script>
